/**
 * The plain standings table the staff screens use (Admin → Leaderboard → View the leaderboard). The player's board and the venue TV
 * are the display screens in ./leaderboardDisplay.ts.
 */

import { deltaSpan, esc } from '../helpers';
import type { LeaderboardEntry } from '../leaderboardClient';

/** The table rows, best first. Exported for tests. */
export function boardRowsHtml(entries: LeaderboardEntry[], highlight: string[]): string {
  const mine = new Set(highlight.map((n) => n.trim().toLowerCase()));
  return entries
    .map(
      (e) => `
      <tr class="${mine.has(e.nickname.toLowerCase()) ? 'winner' : ''}">
        <td>${e.rank}</td>
        <td>${esc(e.nickname)}</td>
        <td>${deltaSpan(e.points)}</td>
        <td>${e.games}</td>
        <td>${e.wins}</td>
      </tr>`,
    )
    .join('');
}
